import React, { useState } from 'react';
import './ProjectsTableRow.scss';
import { useTranslation } from 'react-i18next';
import Project from '../../../models/Project';
import { BidTooltip } from '../../Util/Tooltip/Tooltip';
import { tooltipTitle } from '../../../services/stringUtil';
import { useDispatch, useSelector } from 'react-redux';
import User from '../../../models/User';
import { setInPortfolio } from '../../../redux/actions/allProjects';
import { trackActionClicked } from '../../../api/trackActionClickedApi';
import { TrackedActions } from '../../../models/TrackedActionsEnum';
import BaseModal from '../../Util/Modals/BaseModal';
import { styles as modalStyles } from '../../Util/Modals/Styles';
import { ReactComponent as IconInfo } from '../../../assets/icons/u_info-circle.svg';
import AutoDismissAlert from '../ProjectsReport/view/Common/AlertTooltips';
import { ERROR_IN_ADD_TO_MY_PORTFOLIO, ERROR_IN_REMOVE_FROM_MY_PORTFOLIO, SUCCESSFUL_ADD_TO_MY_PORTFOLIO, SUCCESSFUL_REMOVE_FROM_MY_PORTFOLIO } from './AlertConfigConsts';

type Props = {
  project: Project;
};

const AddToPortfolioButton = ({ project }: Props) => {
  const dispatch = useDispatch();
  const user = useSelector<any, User>(state => state.user);
  const [isConfirmingChange, setIsConfirmingChange] = useState(false);
  const [statusAlert, setStatusAlert] = useState<any>();

  const { t } = useTranslation();

  const handleSetInPortfolio = async (e, projectId) => {
    e.stopPropagation();
    try {
      await dispatch(setInPortfolio(projectId));

      setTimeout(() => {
        setStatusAlert(!project.inPortfolio
          ? SUCCESSFUL_REMOVE_FROM_MY_PORTFOLIO : SUCCESSFUL_ADD_TO_MY_PORTFOLIO);
      }, 300);

    } catch (error) {
      setTimeout(() => {
        setStatusAlert(project.inPortfolio
          ? ERROR_IN_REMOVE_FROM_MY_PORTFOLIO : ERROR_IN_ADD_TO_MY_PORTFOLIO);
      }, 300);      
    }

    trackActionClicked(TrackedActions.addToPorftfolioClicked);
    setStatusAlert(null);
  };

  const handleCancelRemove = (e) => {
    e.stopPropagation(); 
    setIsConfirmingChange(false);
  }

  return user.displayMyPortfolio ? (
    <span onClick={(e) => e.stopPropagation()}>
      {project.inPortfolio ? (
        <BidTooltip
          title={tooltipTitle(t, 'remove_from_my_portfolio')}
          placement="bottom-start"
          enterDelay={500}
          leaveDelay={200}
          arrow
        >
          <span
            onClick={e => {
              e.stopPropagation();
              setIsConfirmingChange(true);
            }}
            className="with-portfolio" id="withPortfolioProject" />
        </BidTooltip>
      ) : (
        <BidTooltip
          title={tooltipTitle(t, 'add_to_my_portfolio')}
          placement="bottom-start"
          enterDelay={500}
          leaveDelay={200}
          arrow
        >
          <span
            onClick={e => handleSetInPortfolio(e, project.id)}
            className="with-portfolio inactive"
            id="withoutPortfolioProject"
          />
        </BidTooltip>
      )}
      <BaseModal
        isOpen={isConfirmingChange}
        style={modalStyles}
        className='confirm-remove-modal'
        shouldCloseOnOverlayClick={false}
        children={
          (
            <div className='confirm-remove-modal-content'>
              <IconInfo />
              <h3>{t('remove_from_my_portfolio_confirmation_title')}</h3>
              <h4>{t('remove_from_my_portfolio_confirmation_message')}</h4>
              <footer style={{ display: 'flex', columnGap: '12px' }}>
                <button
                  className='btn btn-primary-outlined'
                  onClick={handleCancelRemove}>
                  {t('cancel')}
                </button>
                <button
                  className='btn btn-primary'
                  onClick={e => { handleSetInPortfolio(e, project.id); setIsConfirmingChange(false); }}
                >
                  {t('remove')}
                </button>
              </footer>
            </div>
          )
        }
      >
      </BaseModal>
      {statusAlert && (
        <AutoDismissAlert
          message={statusAlert.message}
          title={statusAlert.title}
          severity={statusAlert.severity}
          duration={statusAlert.duration}
          onClose={() => { }}
          closable={false}
          customButtonText={statusAlert.message === SUCCESSFUL_REMOVE_FROM_MY_PORTFOLIO.message ? t('undo') :
            statusAlert.message === ERROR_IN_REMOVE_FROM_MY_PORTFOLIO.message ? t('retry_message') :
              ''}
          onCustomButtonClick={(e) => { handleSetInPortfolio(e, project.id); setIsConfirmingChange(false); }}
        />
      )}
    </span>
  ) : null;
};

export default AddToPortfolioButton;
